import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./HeroSectionB.css";
import {
    Link, 
  } from "react-router-dom";
import background from "../../../assets/images/image2.jpg";
import image1 from "../../../assets/images/image1.jpg";
import image2 from "../../../assets/images/image2.jpg";
import image3 from "../../../assets/images/image3.jpeg";

const images = [image1, image2, image3];

export default function HeroSectionB() {
  const [index, setIndex] = useState(0);
  

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-section">
      {/* Background Image */}
      <div className="hero-background">
        <img src={background} alt="Background" className="background-image" />
      </div>

      {/* Image Zoom Animation */}
      <div className="image-container">
        {images.map((img, i) => (
          <motion.img
            key={i}
            src={img}
            alt={`Hero ${i}`}
            className={`hero-image ${i === index ? "active" : ""}`}
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: i === index ? 1 : 0, scale: i === index ? 1.1 : 1 }}
            transition={{ duration: 1.5 }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="hero-content">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Transforming Industries with Expert Compliance Solutions
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
        >
          Stay ahead with our regulatory expertise in industrial laws, compliance, and statutory reporting.
        </motion.p>
        <div className="cta-buttons">
          <Link to="/services" className="cta-button primary">Learn More</Link>
          <Link to="/contact-us" className="cta-button secondary">Schedule a Consultation</Link>
        </div>
      </div>
    </section>
  );
}
